<template>
  <!-- Title Page -->
  <section>
    <section
      class="bg-title-page flex-c-m p-t-160 p-b-80 p-l-15 p-r-15"
      style="background-image: url(/@/../static/images/bg-title-page-03.jpg);"
    >
      <h2 class="tit6 t-center">體驗活動</h2>
    </section>

    <!-- Content page -->
    <div class="bread-crumb bo5-b p-t-17 p-b-17">
      <div class="container">
        <a href="/" class="txt27">Home</a>

        <span class="txt29 m-l-10 m-r-10">/</span>

        <span class="txt29">體驗活動</span>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-8 col-lg-9">
          <div class="p-t-80 p-b-124 bo5-r h-full p-r-50 p-r-0-md bo-none-md">
            <!-- Block4 -->
            <div
              class="blo4 p-b-63"
              v-for=" (vendorActivity,index) in configBlogData"
              v-if=" (index+1) > ((currentPage-1) * pageSize) && (index+1) <= ((currentPage) * pageSize)"
            >
              <!-- <div v-for=" (vendorActivity,index) in blogInfo.activitys" > -->
              <div class="pic-blo4 hov-img-zoom bo-rad-10 pos-relative">
                <router-link :to="vendorActivity.routeName">
                  <img :src="vendorActivity.activityBlogImages[0]" alt="IMG-BLOG">
                </router-link>
                <div class="date-blo4 flex-col-c-m">
                  <span class="txt30 m-b-4">{{vendorActivity.activityDate.date}}</span>
                  <span
                    class="txt31"
                  >{{vendorActivity.activityDate.month}}, {{vendorActivity.activityDate.year}}</span>
                </div>
              </div>

              <div class="text-blo4 p-t-33">
                <h4 class="p-b-16">
                  <router-link
                    :to="vendorActivity.routeName"
                    class="tit9"
                    style="text-decoration:none;"
                  >{{vendorActivity.activityTitle}}</router-link>
                </h4>

                <div class="txt32 flex-w p-b-24">
                  <span>{{ vendorActivity.vendorName }}</span>
                </div>

                <p v-html="vendorActivity.activityContent[0].substring(0,150) + readMore"></p>
                <router-link
                  :to="vendorActivity.routeName"
                  class="dis-block txt4 m-t-30"
                  style="text-decoration:none;"
                >
                  了解更多
                  <i class="fa fa-long-arrow-right m-l-10" aria-hidden="true"></i>
                </router-link>
              </div>
              <!-- </div> -->
            </div>
            <div class="pagination flex-c-m flex-w p-l-15 p-r-15 m-t-24 m-b-50">
              <!-- <a href="#" class="item-pagination flex-c-m trans-0-4 active-pagination" >1</a>
              <a href="#" class="item-pagination flex-c-m trans-0-4">2</a>-->
              <el-pagination
                layout="pager"
                :total="total"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="handleCurrentChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.tit9 {
  text-decoration: none;
}
.dis-block {
  text-decoration: none;
}
.bread-crumb a {
  text-decoration: none;
}
.bo5-b a {
  text-decoration: none;
}
.el-pager li {
  padding: 0 4px;
  font-size: 13px;
  min-width: 35.5px;
  height: 28px;
  line-height: 35px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-family: Montserrat;
  font-weight: 400;
  font-size: 13px;
  color: #808080;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e6e6e6;
  margin: 6px;
  text-align: center;
}
.el-pager li.active {
  background-color: #333333;
  color: white;
}
.pagination {
  display: flex;
}
.pagination >>> .el-pager li {
  padding: 0 4px;
  font-size: 13px;
  min-width: 35.5px;
  height: 28px;
  line-height: 35px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-family: Montserrat;
  font-weight: 400;
  font-size: 13px;
  color: #808080;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e6e6e6;
  margin: 6px;
  text-align: center;
}
.pagination >>> .el-pager  li.active {
  background-color: #333333;
  color: white;
}
</style>
<script >

export default {
  name: "BlogPage",
  data() {
    return {
      configBlogData: [],
      total: 0,
      pageSize: 4,
      currentPage: 1,
      readMore:" ...."
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      window.scrollTo(0, 300);
      this.$forceUpdate();
    }
  },
  mounted() {
    let self = this;
    const p = new Promise((resolve, reject) => {
      let data = [];
      const readVendorInfo = firebaseDB.ref("activities");
      readVendorInfo.orderByChild("vendorName").on("value", function(snapshot) {
        snapshot.forEach(function(childSnapshot) {
          data.push(childSnapshot.val());
        });
        resolve(data);
      });
    }).then(data => {
      if (data.length != 0) {
        self.configBlogData = data;
        console.log(data);
        if (self.configBlogData.length % self.pageSize >= 1) {
          self.total =
            self.pageSize *
              Math.floor(self.configBlogData.length / self.pageSize) +
            self.pageSize;
        } else if (
          self.configBlogData.length % (self.pageSize * self.currentPage) ==
          0
        ) {
          self.total =
            (self.configBlogData.length / (self.pageSize * self.currentPage))*self.pageSize ;

        }
      }
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/components/BlogPage.vue